import React from 'react'
import Title from "../../components/atoms/Title";
import ButtonT from "../../components/atoms/ButtonT";
import Button from "../../components/atoms/Button";
const HeaderServices = ({name,status,editService,deleteService}) => {
  return (
    <div className="flex flex-row justify-between items-center h-10 ">
    <div className="flex flex-row">
    <Title text={`جزئیات خدمات با شماره “${name}”`} />
   
    </div>
    
    <div className="flex flex-row gap-3.5">
    <Button text={"ویرایش خدمات"} borderBlue="border-blue border-1" textcolor={" text-dark-blue-200"} onClick={editService} />
    <Button text={"حذف خدمات"} borderBlue="border-red border-1" textcolor={"text-red "} onClick={deleteService} />
    <ButtonT text={"برگشت به لیست"} path={"/admin/device/Service"} link={true} />
    </div>
    
  </div>
  )
}

export default HeaderServices
